import { render, staticRenderFns } from "./AdminCaixas.vue?vue&type=template&id=12712450&scoped=true"
import script from "./AdminCaixas.vue?vue&type=script&lang=js"
export * from "./AdminCaixas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12712450",
  null
  
)

export default component.exports